import React, { useCallback, useMemo } from 'react'
import classnames from 'classnames'
import { format } from 'date-fns'

import Tooltip from '../../../../components/Tooltip'

import { ReactComponent as UploadCreativeAssetsIcon } from '../../../../assets/icons/upload-creative-assets-icon.svg'
import { ReactComponent as UploadLogoIcon } from '../../../../assets/icons/upload-logo-file-icon.svg'

import { CREATIVE_ASSETS_FILE_TYPE, LOGO_FILE_TYPE } from '../helpers'

import useStyles from './styles'

const RightActions = ({
  creativeAssetsRequired,
  creativeAssetsDate,
  logoRequired,
  logoDate,
  action,
  openManageFilesClick,
  rightId
}) => {
  const classes = useStyles()

  const formattedCreativeAssetsDate = useMemo(() => {
    return `(due by ${format(new Date(creativeAssetsDate), 'dd MMM yyyy')})`
  }, [creativeAssetsDate])

  const formattedLogoDate = useMemo(() => {
    return `(due by ${format(new Date(logoDate), 'dd MMM yyyy')})`
  }, [logoDate])

  const handleUploadCreativeAssets = useCallback(() => {
    openManageFilesClick(rightId, CREATIVE_ASSETS_FILE_TYPE)
  }, [openManageFilesClick, rightId])

  const handleUploadLogo = useCallback(() => {
    openManageFilesClick(rightId, LOGO_FILE_TYPE)
  }, [openManageFilesClick, rightId])

  if (!creativeAssetsRequired && !logoRequired && !action) {
    return '-'
  }

  return (
    <div>
      {creativeAssetsRequired && (
        <Tooltip
          triggerElement={
            <div className={classes.rightAction} onClick={handleUploadCreativeAssets}>
              <UploadCreativeAssetsIcon className={classes.actionIcon} />
              <p>Upload creative assets {creativeAssetsDate && formattedCreativeAssetsDate}</p>
            </div>
          }
        >
          Upload creative assets
        </Tooltip>
      )}

      {logoRequired && (
        <Tooltip
          triggerElement={
            <div className={classes.rightAction} onClick={handleUploadLogo}>
              <UploadLogoIcon className={classes.actionIcon} />
              <p>Upload logo {logoDate && formattedLogoDate}</p>
            </div>
          }
        >
          Upload logo file
        </Tooltip>
      )}
      {action && <p className={classnames(classes.actionText, classes.rightAction)}>{action}</p>}
    </div>
  )
}

export default RightActions
